<template>
  <div id="app" v-title :data-title="website.web_title" v-if="website.web_title&&loginstatus">
    <router-view/>
    <sidebar @showpoint="showpoint" v-if="loginstatus"/>
    <pointboxtc v-if="modalstatus" :modalstatus="modalstatus" @closepoint="closepoint"/>
  </div>
</template>
<script>
import sidebar from '@/components/sidebar'
import pointboxtc from '@/components/pointboxtc'
import { indexConfig } from "@/api/login";
import { userInfo } from "@/api/user";
export default {
  components:{
    sidebar,
    pointboxtc
  },
  data(){
    return{
      loginstatus:false,
      website:{},
      modalstatus:false,
    }
  },
  created(){
	if(this.$route.query.invite != undefined && this.$route.query.invite != null ) {
		sessionStorage.setItem('inviteCode', this.$route.query.invite)
	}
    console.log("版本1.0.2")
    indexConfig().then(res=>{
      this.website = res.data
      this.$store.website = res.data
    })
    if(localStorage.getItem('gpt-token')){
      userInfo().then(res=>{
        this.$store.userInfo = res.data
        this.loginstatus = true
      })
    }else{
      this.loginstatus = true
    }

  },
  methods:{
    showpoint(){
        this.modalstatus=true
        this.$stopScroll()
    },
    closepoint(){
      this.modalstatus=false
    },
   }
}
</script>
<style lang="less">
  @media (min-width:1000px) {
    #app {
      min-width: 1400px;
    }
    .pc{
      display: block;
    }
    .mobile{
      display: none;
    }
    #sidebar{
      display: block;
    }
  }
  @media (max-width:1000px) {
    .pc{
      display: none;
    }
    .mobile{
      display: block;
      width: 100%;
    }
    #sidebar{
      display: none;
    }
  }
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: -apple-system,BlinkMacSystemFont,PingFang SC,Source Han Sans SC,Helvetica Neue,Microsoft YaHei,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
  }
  * {
    padding: 0;
    margin: 0;
    list-style: none;
    box-sizing: border-box;
  }
  // 去掉a标签的默认样式
  a {
    color: inherit;
    text-decoration: none;
  }
  a:hover {
    color: inherit;
    text-decoration: none;
  }
  a:visited {
    color: inherit;
    text-decoration: none;
  }
  a:active {
    color: inherit;
    text-decoration: none;
  }

</style>
